/**
 * Lazy-loader for submenu content on non-homepage pages.
 * Fetches submenu HTML via AJAX and replaces the placeholder spinner.
 */
import {InitSuperMenu} from './superMenu';

/**
 * Load submenu content for a menu item via AJAX.
 * @param {jQuery} $menuItem - The <li.menu-hover> element containing data-categoryno, data-country, data-lang
 * @returns {Promise} Resolves when submenu content is loaded (or immediately if already loaded)
 */
export function loadSubmenu($menuItem) {
    const $submenu = $menuItem.find('.um-submenu').first();

    // Already loaded or no lazy placeholder — resolve immediately
    if (!$submenu.length || !$submenu.is('[data-lazy="true"]') || $submenu.is('[data-lazy-loaded="true"]')) {
        return Promise.resolve();
    }

    // Already loading — return existing promise to avoid duplicate requests
    if ($menuItem.data('lazyPromise')) {
        return $menuItem.data('lazyPromise');
    }

    const intCategoryNo = $menuItem.attr('data-categoryno');
    const strCountry    = $menuItem.attr('data-country');
    const strLang       = $menuItem.attr('data-lang');

    if (!intCategoryNo) {
        return Promise.resolve();
    }

    const promise = new Promise((resolve, reject) => {
        $.get(
            strPath + 'ajax/menu-submenu.php',
            {
                categoryno:  intCategoryNo,
                countrycode: strCountry,
                langcode:    strLang
            },
            function (html) {
                // Replace the entire placeholder div with the AJAX-rendered submenu
                // The partial returns the full <div class="um-submenu supermenu-sub">...</div>
                const $newSubmenu = $(html);
                $newSubmenu.attr('data-lazy', 'true');
                $newSubmenu.attr('data-lazy-loaded', 'true');
                $submenu.replaceWith($newSubmenu);

                // Re-initialize click handlers on the newly loaded DOM elements
                InitSuperMenu($newSubmenu.find('[data-action]'));

                resolve();
            },
            'html'
        ).fail(function () {
            // On error, remove spinner and show empty submenu (graceful degradation)
            $submenu.find('.um-lazy-spinner').remove();
            reject();
        });
    });

    $menuItem.data('lazyPromise', promise);

    // Clean up stored promise after completion
    promise.finally(() => {
        $menuItem.removeData('lazyPromise');
    });

    return promise;
}
